module.exports = __webpack_public_path__ + "img/buyGif.a485f5b5.gif";